import React from "react";

function InventoryRow({
  key,
  index,
  item,
  page,
  limit,
  setModalOpen,
  onShowLabel,
}) {
  const isLow = item.available > 0 && item.available <= item.alertQuantity;
  const isOut = item.available <= 0;

  return (
    <>
      <tr key={item.id}>
        <td>
          <div className="fw-semibold small">
            {item.productName || `Variant #${item.productVariantId}`}
          </div>
          {item.variantName && (
            <div className="text-muted small">{item.variantName}</div>
          )}
        </td>
        <td>
          <code className="small">{item.sku}</code>
        </td>
        <td className="small">{item.wareHouseId}</td>
        <td
          className={`text-end fw-semibold ${isOut ? "text-danger" : isLow ? "text-warning" : ""}`}
        >
          {item.stock}
          {isOut && <i className="ti ti-x-circle ms-1" />}
          {isLow && !isOut && <i className="ti ti-alert-triangle ms-1" />}
        </td>
        <td className="text-end text-muted small">{item.alertQuantity}</td>
        <td>
          <a className="me-2 p-2" onClick={() => setModalOpen(true)}>
            <i className="ti ti-pencil" />
          </a>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary ms-1"
            title="Barcode / QR"
            onClick={() => onShowLabel(item)}
          >
            <i className="ti ti-barcode" />
          </button>
        </td>
      </tr>
    </>
  );
}

export default InventoryRow;
